import { hydrateRoot } from 'react-dom/client';
import type { PublicPageResponse } from '@kfz/shared';
import { App } from './App';

const dataElement = document.getElementById('__KFZ_DATA__');
const data = dataElement ? (JSON.parse(dataElement.textContent || '{}') as PublicPageResponse) : null;
const root = document.getElementById('root');

if (data && root) hydrateRoot(root, <App data={data} />);
